<template>
<!-- 商城 -->
    <div class="ShoppingMall">
        <div class="content">
            <img src="../assets/icon @2x.png">
            <p>此功能正在紧张开发中</p>
            <p>敬请期待...</p>
        </div>
        <footer class="footer">
            <ul>
                <li>
                    <router-link :to="{name: 'Home'}">
                        <img src="../assets/icon_shouye@2x.png" alt="首页图标">
                        <p>首页</p>
                    </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'VisionReport'}">
                        <img src="../assets/icon_shilibaogao @2x.png" alt="视力报告">
                        <p>视力报告</p>
                    </router-link>
                </li>
                <li>
                    <img src="../assets/icon_shangcheng@2x.png" alt="商城图标">
                    <p>商城</p>
                </li>
            </ul>
        </footer>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.ShoppingMall {
    height: 100%;
}
.content {
    color: #3f8ed4;
    text-align: center;
    background: #fff;
    height: 100%;
}
.content img {
    margin-top: 200px;
    width: 420px;
}

.content p:first-of-type {
    font-size: 36px;
    margin: 80px 0 30px;
}
.content p:last-of-type {
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/ShoppingMall.vue